const updateActionsStore = {
  toastr: 'Acción actualizada',
  toastrError1: 'No autorizado (Creado por otro usuario)',
  toastrError2: 'No autorizado (No estas entre los responsables)',
  toastrError3: 'No autorizado',
};

export default updateActionsStore;
